import type moment from 'moment'

import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { useAddUnassignedShifts } from 'modules/shift_management/hooks/useAddUnassignedShifts'
import UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface Props {
  date: moment.Moment
}

const useUnassignedCustomShiftForm = ({ date }: Props) => {
  const unassignedShiftForm = useLazyRef<UnassignedShiftForm>(
    () =>
      new UnassignedShiftForm({
        start_date: date,
        end_date: date,
        staff_requirements: [{ job_catalog_roles_ids: [], staff_count: 1 }],
      })
  ).current

  const useSubmitUnassignedCustomShift = () => {
    const { onSubmit, submitting } = useAddUnassignedShifts({
      form: unassignedShiftForm,
    })

    return {
      onSubmit,
      submitting,
    }
  }

  return {
    unassignedShiftForm,
    useSubmitUnassignedCustomShift,
  }
}

export default useUnassignedCustomShiftForm
